export const getProductDeal = (product) => {
  return (
    product?.deals?.find((d) => d.isActive) ||
    product?.Deals?.find((d) => d.IsActive) ||
    product?.productDeals?.find((d) => d.isActive) ||
    product?.ProductDeals?.find((d) => d.IsActive) ||
    product?.deals?.[0] ||
    product?.Deals?.[0] ||
    null
  );
};

export const getDealLabel = (product) => {
  const deal = getProductDeal(product);

  if (!deal) return null;

    console.log("product:", product);
  console.log("deal:", deal);

  const dealType = Number(deal.dealType ?? deal.DealType);
  const quantity = Number(deal.quantity ?? deal.Quantity);
  const dealPrice = deal.dealPrice ?? deal.DealPrice;
  const discountPercent = deal.discountPercent ?? deal.DiscountPercent;

  // BuyXGetOneFree
  if (dealType === 1) {
    return `${quantity}+1`;
  }

  // XForPrice
  if (dealType === 2) {
    return `${quantity} ב-${dealPrice} ₪`;
  }

  // PercentDiscount
  if (dealType === 3) {
    return `${discountPercent}% הנחה`;
  }

  return null;
};